import styled from 'styled-components';
import { toRemStr } from '../../utils/helpers';

export const WeekInlineCalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${toRemStr(12)};
  margin-top: var(--s1);
`;

export const WeekInlineCalendarPickerWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--s2);
  margin-bottom: var(--s2);
`;
